var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35714 2.14286V13.9286H9.64286V2.14286C9.64286 1.8587 9.52997 1.58617 9.32904 1.38524C9.12811 1.18431 8.85559 1.07143 8.57143 1.07143H6.42857C6.14441 1.07143 5.87189 1.18431 5.67096 1.38524C5.47003 1.58617 5.35714 1.8587 5.35714 2.14286ZM4.28571 6.42857V2.14286C4.28571 1.57454 4.51148 1.02949 4.91334 0.627628C5.31521 0.225765 5.86025 0 6.42857 0H8.57143C9.13975 0 9.68479 0.225765 10.0867 0.627628C10.4885 1.02949 10.7143 1.57454 10.7143 2.14286V3.21429H12.8571C13.4255 3.21429 13.9705 3.44005 14.3724 3.84191C14.7742 4.24378 15 4.78882 15 5.35714V14.4643C15 14.6064 14.9436 14.7426 14.8431 14.8431C14.7426 14.9436 14.6064 15 14.4643 15H0.535714C0.393634 15 0.257373 14.9436 0.156907 14.8431C0.0564413 14.7426 0 14.6064 0 14.4643V8.57143C0 8.00311 0.225765 7.45806 0.627628 7.0562C1.02949 6.65434 1.57454 6.42857 2.14286 6.42857H4.28571ZM4.28571 13.9286V7.5H2.14286C1.8587 7.5 1.58617 7.61288 1.38524 7.81381C1.18431 8.01475 1.07143 8.28727 1.07143 8.57143V13.9286H4.28571ZM10.7143 13.9286H13.9286V5.35714C13.9286 5.07298 13.8157 4.80046 13.6148 4.59953C13.4138 4.3986 13.1413 4.28571 12.8571 4.28571H10.7143V13.9286Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideGraph);
export default __webpack_public_path__ + "static/media/side_graph.8718dc10.svg";
export { ForwardRef as ReactComponent };